import React from 'react';
import AdmBlogCard from '../../../components/admin/AdminBlogs/AdmBlogCard';
import '../../../assets/css/admin/adminBlogs/admbloglist.css';

const AdminBlogsList = () => {
  return (
    <div className="adm-blog-list-container">
      <AdmBlogCard />
    </div>
  );
};

export default AdminBlogsList;